export default __webpack_public_path__ + "static/media/HRRealCase-mobile.7a28e163.jpg";